import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Divider, Paper } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import { LEGAL_INDEX, COMPANY } from '../legal/legalContent.js';

// Landing page at /legal listing all legal documents.
function LegalIndexPage() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#f7fafc' }}>
      <Navbar />

      <Box
        component="main"
        sx={{
          flex: 1,
          width: '100%',
          maxWidth: 820,
          mx: 'auto',
          px: { xs: 2.5, sm: 4 },
          py: { xs: 4, sm: 6 },
        }}
      >
        <Typography variant="h4" component="h1" sx={{ fontWeight: 800, color: '#1e3a4f' }}>
          Legal
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          Effective date: {COMPANY.effectiveDate}
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, color: '#42606f', lineHeight: 1.7 }}>
          The documents below govern the use of {COMPANY.brand} ({COMPANY.website}), operated by{' '}
          {COMPANY.legalName}.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {LEGAL_INDEX.map((item) => (
            <Paper
              key={item.slug}
              variant="outlined"
              onClick={() => navigate(item.path)}
              sx={{
                p: 2.5,
                borderRadius: 2,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                transition: 'border-color 0.15s, box-shadow 0.15s',
                '&:hover': { borderColor: 'primary.main', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' },
              }}
            >
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#23495f' }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ mt: 0.5, color: '#5a7280' }}>
                  {item.description}
                </Typography>
              </Box>
              <ChevronRightIcon sx={{ color: 'text.secondary', flexShrink: 0 }} />
            </Paper>
          ))}
        </Box>
      </Box>

      <Footer />
    </Box>
  );
}

export default LegalIndexPage;
